import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  ReferenceArrayInput,
  SelectArrayInput,
  ArrayInput,
  SimpleFormIterator,
  useNotify,
  useRedirect,
  useCreate,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { htmlToBlocks } from '../../../helpers/htmlUtils';

function IndustriaCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = (data: any) => {
    const payload = {
      ...data,
      descripcion: htmlToBlocks(data.descripcion) || [],
      beneficios: htmlToBlocks(data.beneficios) || [],
      experiencia: data.experiencia.map((block: any) => ({
        ...block,
        contenido: htmlToBlocks(block.contenido) || [],
        __component: 'shared.caracteristica',
      })),
    }

    create(
      'industries',
      { data: payload },
      {
        onSuccess: () => {
          notify('Elemento creado');
          redirect('list', 'industries');
        },
        onError: (error: any) => {
          notify(`Error: ${error.message}`, { type: 'error' });
        },
      }
    );
  };

  useEffect(() => {
    document.title = 'Crear Industria';
  }, []);

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="nombre" validate={[required()]} />
        <FileInput source="icono" label="Icono" validate={[required()]}>
          <ImageField source="src" title="title" />
        </FileInput>
        <FileInput source="logo" label="Logo">
          <ImageField source="src" title="title" />
        </FileInput>
        <RichTextInput source="descripcion" />
        <RichTextInput source="beneficios" />
        <ArrayInput source="experiencia" label="Experiencia">
          <SimpleFormIterator>
            <FileInput source="imagen" label="Imagen" className='mt-8'>
              <ImageField source="src" />
            </FileInput>
            <RichTextInput source="contenido" label="Contenido" />
          </SimpleFormIterator>
        </ArrayInput>
        <TextInput source="nombre_industria" validate={[required()]} />
        <TextInput source="slug" validate={[required()]} />
        <TextInput source="titulo_pestana" validate={[required()]} />
        <FileInput source="banner" label="Imagen de Banner">
          <ImageField source="src" title="title" />
        </FileInput>
        <FileInput source="imagen_beneficios" label="Imagen de Beneficios">
          <ImageField source="src" title="title" />
        </FileInput>
        <ReferenceArrayInput source='soluciones_energeticas' reference='solucion-energeticas' label='Soluciones Energéticas'>
          <SelectArrayInput optionText="nombre" />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  )
}

export default IndustriaCreate;